import { Report196Container } from "../../../containers/borrowSystem/Report/Report196Container";

export function Report196Page() {
    return (
        <Report196Container />
    )
}